import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { NgMessageMap } from "./shared/ng-message-map";
import { Title } from "@angular/platform-browser";
import { NgRequest } from "./shared/ng-request";
import { NgMessage } from "./shared/ng-message";
import { CaptchaData } from "./shared/captcha-data";

@Injectable()
export class AppContext
{
  messages: NgMessageMap;
  buildVersion: string;
  public appInsights: ApplicationInsights;
  public captchaData: CaptchaData;

  private readonly runModeKey = 'SACS:AppContext:runMode';
  private readonly testRunIdKey = 'SACS:AppContext:testRunId';
  private readonly timeZoneId: string;

  setReferenceData(
    messages: Array<NgMessage>,
    buildVersion: string): void {
    this.buildVersion = buildVersion;

    this.messages = new NgMessageMap();
    for (const message of messages)
      this.messages[message.code] = message;
  }

  set runMode(value: string) {
    if (value)
      sessionStorage.setItem(this.runModeKey, value);
    else
      sessionStorage.removeItem(this.runModeKey);
  }

  get runMode(): string {
    return sessionStorage.getItem(this.runModeKey);
  }

  set testRunId(value: string) {
    if (value)
      sessionStorage.setItem(this.testRunIdKey, value);
    else
      sessionStorage.removeItem(this.testRunIdKey);
  }

  get testRunId(): string {
    return sessionStorage.getItem(this.testRunIdKey);
  }

  createRequest<TRequest>(request: TRequest): NgRequest<TRequest>
  {
    return NgRequest.create(request, this.runMode, this.testRunId, this.timeZoneId);
  }

  constructor(private readonly title: Title) {
    try {
      this.timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    catch (e) {
      this.timeZoneId = 'America/Los_Angeles';
    }
  }
}
